// A short foreground wait, never a claim that queued matching has finished.
export class ManualMatchingFeedback {
  show(onContinue) {
    const template = document.getElementById("manual-matching-splash")
    this.view = template.content.firstElementChild.cloneNode(true)
    this.started = Date.now()
    this.deadline = this.started + 3000
    this.view.querySelector("button").addEventListener("click", () => {
      this.close()
      onContinue()
    })
    window.proximityManualMatching = true
    document.body.append(this.view)
    this.timer = setTimeout(() => this.close(), 3000)
    this.view.querySelector("button").focus()
  }

  async waitForResult(result, { keepOpen = false } = {}) {
    const runKey = result.run_key
    while (this.view && Date.now() < this.deadline) {
      if (result.status === "complete" || result.status === "already_up_to_date") break
      if (!result.run_key) break
      const abort = new AbortController()
      const timer = setTimeout(() => abort.abort(), Math.max(1, this.deadline - Date.now()))
      try {
        const response = await fetch(`/library_photos/matching_result?run_key=${encodeURIComponent(result.run_key)}`,
          { credentials: "same-origin", signal: abort.signal })
        if (!response.ok) break
        const next = await response.json()
        if (next.status === "complete") { result = next; break }
      } catch (_) { break }
      finally { clearTimeout(timer) }
      await new Promise(resolve => setTimeout(resolve, 250))
    }
    if (this.view && result.status === "complete") {
      const user = document.querySelector("[data-notification-badge-user-id-value]")?.dataset.notificationBadgeUserIdValue
      try {
        sessionStorage.setItem(`manual-matching-result:${user}`, JSON.stringify({ matches: result.matches, at: Date.now() }))
        if (result.matches === false && runKey) {
          sessionStorage.setItem(`manual-matching-banner:${user}`, JSON.stringify({ runKey, at: Date.now() }))
        }
      }
      catch (_) { /* Navigation still works without storage. */ }
    }
    if (this.view) await new Promise(resolve => setTimeout(resolve, Math.max(0, 1500 - (Date.now() - this.started))))
    if (keepOpen && this.view) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.close(), 3000)
    } else {
      this.close()
    }
  }

  close() {
    clearTimeout(this.timer)
    this.view?.remove()
    this.view = null
    window.proximityManualMatching = false
  }
}
